module.exports = __webpack_public_path__ + "static/turquia-018.thumb-1645b4cecfc4d35d4d6f4b9fe9fe6504.jpg";